import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { FormRule } from "@/modules/FormTemplate/models/FormRule";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Vuetify from "vuetify";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { Field } from "@/modules/FormTemplate/models/Field";

Vue.use(Vuetify);

@Component({
  name: "RuleComponent",
  components: {
    EmptyState
  }
})
export default class RuleComponent extends Vue {
  @Prop() private fields!: Field[];
  @Prop() private formRules!: FormRule[];

  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  cardClass = STYLE_CLASSES.CARD;
  RULE_EMPTY_STATE_HEADER = FORM_TEMP_CONSTANTS.RULE_LABEL.EMPTY_STATE_TITLE;
  RULE_EMPTY_STATE_PARAGRAPH =
    FORM_TEMP_CONSTANTS.RULE_LABEL.EMPTY_STATE_PARAGRAPH;
  EDIT_RULE =
    FORM_TEMP_CONSTANTS.RULE_COMPONENT_TOOLTIPS.BTN_TOOLTIPS.EDIT_RULE;
  DELETE_RULE =
    FORM_TEMP_CONSTANTS.RULE_COMPONENT_TOOLTIPS.BTN_TOOLTIPS.DELETE_RULE;
  editRule(index: number) {
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.RULE.EDIT, index);
  }

  deleteRule(index: number) {
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.RULE.DELETE, index);
  }
}
